var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeploy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 107,
    viewBox: "0 0 76 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8101 47.0901C22.8101 47.0901 12.6301 59.0001 22.8101 74.0001C22.8101 74.0001 21.46 64.22 26.23 61.61",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.85 69V80",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 98.9999C75 104.52 70.52 106 65 106H11C5.48 106 1 104.52 1 98.9999C0.999762 96.7422 1.76348 94.5508 3.16699 92.7824C4.57051 91.0139 6.5312 89.7724 8.72998 89.2599C8.90088 88.825 9.10479 88.4037 9.33997 87.9999C10.2176 86.4798 11.48 85.2174 13.0001 84.3397C14.5203 83.462 16.2447 83 18 82.9999C19.4107 82.9957 20.8058 83.2959 22.09 83.8799C23.033 82.6625 24.2445 81.6794 25.6299 81.0071C27.0153 80.3348 28.5373 79.9917 30.0771 80.0042C31.617 80.0168 33.1332 80.3849 34.5074 81.0797C35.8817 81.7745 37.077 82.7773 38 84.0099C38.923 82.7773 40.1183 81.7745 41.4926 81.0797C42.8668 80.3849 44.383 80.0168 45.9229 80.0042C47.4627 79.9917 48.9847 80.3348 50.3701 81.0071C51.7555 81.6794 52.967 82.6625 53.91 83.8799C55.1942 83.2959 56.5893 82.9957 58 82.9999C59.7553 83 61.4797 83.462 62.9999 84.3397C64.52 85.2174 65.7824 86.4798 66.66 87.9999C66.8952 88.4037 67.0991 88.825 67.27 89.2599C69.4688 89.7724 71.4295 91.0139 72.833 92.7824C74.2365 94.5508 75.0002 96.7422 75 98.9999V98.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93.0001C28.0033 90.676 27.197 88.4233 25.7196 86.6291C24.2422 84.835 22.1859 83.6114 19.9043 83.1689C17.6227 82.7263 15.2582 83.0922 13.2172 84.2038C11.1761 85.3154 9.58589 87.1033 8.71997 89.2601",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69H47C65 27 38 1 38 1C38 1 11 27 29 69H38Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.15 69V80",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93.0001C47.9967 90.676 48.803 88.4233 50.2804 86.6291C51.7578 84.835 53.8141 83.6114 56.0957 83.1689C58.3773 82.7263 60.7418 83.0922 62.7828 84.2038C64.8239 85.3154 66.4141 87.1033 67.28 89.2601",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.37 17.71H48.33",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.23 61.61H49.77C54.54 64.22 53.1899 74.0001 53.1899 74.0001C63.3699 59.0001 53.1899 47.0901 53.1899 47.0901",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40C41.866 40 45 36.866 45 33C45 29.134 41.866 26 38 26C34.134 26 31 29.134 31 33C31 36.866 34.134 40 38 40Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploy);
export default __webpack_public_path__ + "static/media/deploy.21c3009bb607c1287bf9f6e2ef30b10e.svg";
export { ForwardRef as ReactComponent };